"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ɵngcc0 = require('@angular/core');
var Ng2FrameworkFactory = /** @class */ (function () {
    function Ng2FrameworkFactory(_ngZone) {
        this._ngZone = _ngZone;
    }
    Ng2FrameworkFactory.prototype.setTimeout = function (action, timeout) {
        this._ngZone.runOutsideAngular(function () {
            window.setTimeout(function () {
                action();
            }, timeout);
        });
    };
    /** @nocollapse */
    Ng2FrameworkFactory.ctorParameters = function () { return [
        { type: core_1.NgZone, },
    ]; };
Ng2FrameworkFactory.ɵfac = function Ng2FrameworkFactory_Factory(t) { return new (t || Ng2FrameworkFactory)(ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); };
Ng2FrameworkFactory.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: Ng2FrameworkFactory, factory: function (t) { return Ng2FrameworkFactory.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Ng2FrameworkFactory, [{
        type: core_1.Injectable
    }], function () { return [{ type: ɵngcc0.NgZone }]; }, null); })();
    return Ng2FrameworkFactory;
}());
exports.Ng2FrameworkFactory = Ng2FrameworkFactory;

